(function () {

	function depsReady() {
		return !!(window.wp && window.wp.data);
	}

	function blocksReady() {
		return !!(window.wc && window.wc.wcBlocksData);
	}

	function boot() {

		const { select, subscribe } = window.wp.data;

		// cart store key is usually available even if wcBlocksData isn't
		const CART_STORE_KEY = (window.wc && window.wc.wcBlocksData && window.wc.wcBlocksData.CART_STORE_KEY) || "wc/store/cart";


		const seen = new Set();

		function getNoticesWrapper() {
			return (
				document.querySelector(".wc-block-components-notices") ||
				document.querySelector(".wc-block-store-notices") ||
				document.querySelector("[data-block-name='woocommerce/store-notices']")
			);
		}

		function renderNotices(notices) {
			const wrapper = getNoticesWrapper();
			if (!wrapper) {
				return false;
			}

			notices.forEach((n) => {
				const key = (n.code || n.message || "") + ":" + (n.ts || "");
				if (seen.has(key)) return;
				seen.add(key);

				const type = (n.type || "notice").toLowerCase();

				const banner = document.createElement("div");
				banner.className = "wc-block-components-notice-banner";
				banner.setAttribute("data-mpb-notice", key.replace(/[^a-z0-9:_-]/gi, ""));
				banner.setAttribute("role", type === "error" ? "alert" : "status");

				if (type === "error") banner.classList.add("is-error");
				else if (type === "success") banner.classList.add("is-success");
				else banner.classList.add("is-info");

				const content = document.createElement("div");
				content.className = "wc-block-components-notice-banner__content";
				content.textContent = n.message || "";

				banner.appendChild(content);
				wrapper.prepend(banner);
			});

			return true;
		}

		let lastSnapshot = "";

		subscribe(function () {
			const cartStore = select(CART_STORE_KEY);
			if (!cartStore || typeof cartStore.getCartData !== "function") return;

			const cartData = cartStore.getCartData();
			const mpb = cartData?.extensions?.mpb || null;

			const snapshot = JSON.stringify(mpb || {});
			if (snapshot === lastSnapshot) return;
			lastSnapshot = snapshot;

			const notices = Array.isArray(mpb?.notices) ? mpb.notices : [];
			if (!notices.length) return;

			let tries = 0;
			(function tryRender() {
				tries++;
				if (renderNotices(notices)) return;
				if (tries < 20) setTimeout(tryRender, 150);
			})();
		});

	}

	// Wait for wp.data first, then (optionally) wcBlocksData.
	let attempts = 0;
	(function waitForDeps() {
		attempts++;

		if (!depsReady()) {
			if (attempts < 200) return setTimeout(waitForDeps, 50);
			return;
		}

		// wcBlocksData is nice-to-have; we can still proceed without it.
		if (!blocksReady() && attempts < 200) {
			// keep waiting a bit so CART_STORE_KEY can be read from wcBlocksData if it appears
			return setTimeout(waitForDeps, 50);
		}

		boot();
	})();
})();
